<template>
  <div>
    <table class="equipments">
      <tr>
        <td class="weapon" rowspan="2">
          <img v-if="leftWeapon" id="equipments-left-weapon" :src="getImgUrl(leftWeapon.img)" :width="leftWeapon.width">
          <EquipmentTooltip v-if="leftWeapon" target-id="equipments-left-weapon" :item="leftWeapon"/>
        </td>
        <td class="helm">
          <img v-if="helm" id="equipments-helm" :src="getImgUrl(helm.img)" :width="helm.width">
          <EquipmentTooltip v-if="helm" target-id="equipments-helm" :item="helm"/>
        </td>
        <td class="weapon" rowspan="2">
          <img v-if="rightWeapon" id="equipments-right-weapon" :src="getImgUrl(rightWeapon.img)" :width="rightWeapon.width">
          <EquipmentTooltip v-if="rightWeapon" target-id="equipments-right-weapon" :item="rightWeapon"/>
        </td>
      </tr>
      <tr>
        <td class="armor">
          <img v-if="armor" id="equipments-armor" :src="getImgUrl(armor.img)" :width="armor.width">
          <EquipmentTooltip v-if="armor" target-id="equipments-armor" :item="armor"/>
        </td>
      </tr>
      <tr v-if="showLowerBody">
        <td class="gloves">
          <img v-if="gloves" id="equipments-gloves" :src="getImgUrl(gloves.img)" :width="gloves.width">
          <EquipmentTooltip v-if="gloves" target-id="equipments-gloves" :item="gloves"/>
        </td>
        <td class="belt">
          <img v-if="belt" id="equipments-belt" :src="getImgUrl(belt.img)" :width="belt.width">
          <EquipmentTooltip v-if="belt" target-id="equipments-belt" :item="belt"/>
        </td>
        <td class="boots">
          <img v-if="boots" id="equipments-boots" :src="getImgUrl(boots.img)" :width="boots.width">
          <EquipmentTooltip v-if="boots" target-id="equipments-boots" :item="boots"/>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import EquipmentTooltip from './EquipmentTooltip.vue'

export default {
  name: 'Equipments',

  components: {
    EquipmentTooltip,
  },

  props: {
    helm: {
      type: Object
    },
    leftWeapon: {
      type: Object
    },
    rightWeapon: {
      type: Object
    },
    armor: {
      type: Object
    },
    gloves: {
      type: Object
    },
    belt: {
      type: Object
    },
    boots: {
      type: Object
    },
    showLowerBody: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    getImgUrl(imageName) {
      let images = require.context('@/assets/builds/', false, /\.png$/)
      return images('./' + imageName + ".png")
    }
  },
}
</script>

<style scoped>
.equipments td {
  border:20px solid;
  border-color: transparent;
}
.equipments td img{
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.helm {
  background-image:url(../../assets/builds/eq-helm.png);
  background-repeat:no-repeat;
  background-size:95px 95px;
  width: 115px; 
  height: 115px;
  background-position: center;
}
.weapon {
  background-image:url(../../assets/builds/eq-weapon.png);
  background-repeat:no-repeat;
  background-size:100px 208px;
  width: 120px; 
  height: 228px;
  background-position: center;
}
.armor {
  background-image:url(../../assets/builds/eq-armor.png);
  background-repeat:no-repeat;
  background-size:95px 134px;
  width: 115px; 
  height: 154px;
  background-position: center;
}
.gloves {
  background-image:url(../../assets/builds/eq-gloves.png);
  background-repeat:no-repeat;
  background-size:100px 100px;
  width: 120px; 
  height: 120px;
  background-position: center;
}
.belt {
  background-image:url(../../assets/builds/eq-belt.png);
  background-repeat:no-repeat;
  background-size:95px 54px;
  width: 115px; 
  height: 74px;
  background-position: center;
}
.boots {
  background-image:url(../../assets/builds/eq-boots.png);
  background-repeat:no-repeat;
  background-size:100px 100px;
  width: 120px; 
  height: 120px;
  background-position: center;
}
</style>